import React from 'react';

import { ColoredIllustrationErrorExplodingBalloon } from '@klarna/bubble-ui';

import InformationContainer from './InformationContainer';

const tPrefix = 'products-fe.pages.whats_next_page.suspended';

const Rejection = props => (
  <InformationContainer
    Icon={ColoredIllustrationErrorExplodingBalloon}
    tPrefix={tPrefix}
    tPrefixList={`${tPrefix}.content.list`}
    hasFooter
    {...props}
  />
);

export default Rejection;
